import * as React from 'react'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import { GnbSearch } from '../Search'
import CategoryButton from './CategoryButton'
import { GnbLogin } from './GnbLogin'
import MyButton from './MyButton'
import hostConfig from 'common/config'

import * as s from './gnb.scss'

interface OwnProps {
  cx?: DynamicCx
}

const SiteButton = ({ cx }) => {
  const shoppingSearchUri = hostConfig.shoppingSearchUri[process.env.PROJECT_NAME]
  return (
    <div className={cx('shop_site')}>
      <a href={`${shoppingSearchUri}/best100v2/main.nhn`} className={cx('link_best', '@N=a:SNB.best100')}>
        베스트 100
      </a>
      <span className={cx('bar')}>|</span>
      <a href={`${shoppingSearchUri}/mall/mall.nhn`} className={cx('link_mall', '@N=a:SNB.mall')}>
        몰전체보기
      </a>
    </div>
  )
}

const Gnb: React.SFC<OwnProps> = ({ cx }) => {
  const shoppingWeb = hostConfig.shoppingWebUri[process.env.PROJECT_NAME]
  const shoppingWebUrl = `${shoppingWeb.protocol}://${shoppingWeb.host}`
  const orderUrl = hostConfig.naverPayUri.pcOrder

  return (
    <>
      <div className={cx('header_gnb')}>
        <div className={cx('header_inner')}>
          <div className={cx('main_site')}>
            <a href="https://www.naver.com" className={cx('link_naver', '@N=a:GNB.naver')} title="나의 경쟁력, 네이버">
              NAVER
            </a>
            <a
              href={`${orderUrl}/home?frm=s_logo`}
              className={cx('link_npay', '@N=a:GNB.naverpay')}
              title="네이버 아이디로 간편구매, 네이버페이">
              네이버페이
            </a>
          </div>
          <div className={cx('shopping_gnb_wrap')}>
            <GnbLogin />
          </div>
        </div>
      </div>
      <div className={cx('header_shop')}>
        <div className={cx('header_inner')}>
          <h1 className={cx('title')}>
            <a href={shoppingWebUrl} className={cx('@N=a:SNB.home')}>
              네이버 쇼핑
            </a>
          </h1>
          <GnbSearch />
          <CategoryButton cx={cx} />
          <SiteButton cx={cx} />
          <MyButton cx={cx} />
        </div>
      </div>
    </>
  )
}

const styled = styling(s)(Gnb)
export default styled
